import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { AutoComplete, MenuItem, TextField } from 'material-ui';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import styles from 'styles';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

/**
 * 
 * @param {Props} props 
 */
export default function RealCargoNameAutoComplete({
    cargoTypes, saveStatusCargoAssigner, _preventFirstSearch = true, ...props
}) {
    const [realCargoNames, setRealCargoNames] = useState([]);
    const [item, setItem] = useState(props.item);
    const [preventFirstSearch, setPreventFirstSearch] = useState(_preventFirstSearch);

    const debouncedSearchValue = useDebounce(item.name, 500);

    useEffect(() => {
        if (preventFirstSearch || !debouncedSearchValue || debouncedSearchValue.length < 2) {
            return;
        }

        api.getCargoNamesAutocomplete(debouncedSearchValue)
            .then((response) => {
                const _realCargoNames = response.data.data.map(realCargoName => ({
                    name: realCargoName.name,
                    item: (<MenuItem
                        value={realCargoName}
                        primaryText={realCargoName.name}
                        secondaryText={
                            ['admin', 'moderator'].includes(realCargoName.addedByRole) && 
                            <SettingsIcon 
                                style={{ 
                                    position: 'absolute', 
                                    left: -10, 
                                    marginTop: '11px',
                                    color: '#9E9E9E',
                                }} 
                            />
                        }
                        style={{ paddingLeft: '25px' }}
                    />),
                }));

                setRealCargoNames(_realCargoNames);
                document.body.scrollTop += 1;
                document.body.scrollTop -= 1;
            })
            .catch(() => null);
    }, [debouncedSearchValue]);

    useEffect(() => {
        setPreventFirstSearch(!_preventFirstSearch);
    }, []);

    useEffect(() => {
        setItem(props.item);
    }, [props.item]);

    const onUpdateInputCargoName = (searchText) => {
        props.updateItem({
            ...item,
            name: searchText,
            isUpdate: { ...item, name: searchText },
            // _id: undefined, // if we set _id to undefined then we will not update existing cargo
        });
    };

    const onNewRequestRealCargoNames = (updateProperties) => {
        if (!updateProperties) {
            return;
        }

        const _item = _.cloneDeep(item);

        if (updateProperties.item.props.value.parent) {
            cargoTypes.forEach((cargoType) => {
                if (updateProperties.item.props.value.parent.red._id === cargoType._id) {
                    _item.parent.red._id = cargoType._id;
                    _item.parent.red.name = cargoType.name;
                }
            });
        }

        _item.name = updateProperties.name;
        _item._id = updateProperties.item.props.value._id;
        _item.details = updateProperties.item.props.value.details;
        _item.isUpdate = true;

        props.updateItem(_item);
        setRealCargoNames([]);
        saveStatusCargoAssigner && saveStatusCargoAssigner(_item);
    };

    const inputCargoName = (value) => {
        const _item = _.cloneDeep(item);
        
        _item.name = value;

        props.updateItem(_item);
    };

    return (
        <React.Fragment>
            {
                props.isAutoComplete ?
                    <AutoComplete
                        textFieldStyle={styles.autoCompleteCSS}
                        hintText='Real cargo name'
                        floatingLabelText='Real cargo name'
                        searchText={item.name || ''}
                        dataSource={realCargoNames}
                        dataSourceConfig={{ text: 'name', value: 'item' }}
                        onUpdateInput={onUpdateInputCargoName}
                        onNewRequest={onNewRequestRealCargoNames}
                        filter={AutoComplete.noFilter}
                        listStyle={styles.autoCompleteListStyle}
                        inputStyle={{ fontSize: '16px' }}
                        disabled
                        popoverProps={{
                            canAutoPosition: true,
                            anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                            targetOrigin: { horizontal: 'left', vertical: 'top' },
                        }}
                    /> 
                    :
                    <TextField
                        value={item.name || ''}
                        hintText='Real cargo name'
                        floatingLabelText='Real cargo name'
                        onChange={e => inputCargoName(e.target.value)}
                        style={{ fontSize: '16px' }}
                    />
            }
        </React.Fragment>
    );
}

/**
 * props
 * @typedef {Object} Props
 * @property {import('../Cargoes/Assigners/UpdateRealCargoDialog.jsx').RealCargo} item
 * @property {any} cargoTypes
 * @property {Function} [saveStatusCargoAssigner]
 * @property {boolean} _preventFirstSearch
 * @property {Function} updateItem
 * @property {boolean} isAutoComplete
 */




// WEBPACK FOOTER //
// ./app/components/common/RealCargoNameAutoComplete.jsx